import * as React from "react";
import { PropsWithChildren } from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import { useStyles } from "./Menu.styles";
import { Copyright } from "../Copyright/Copyright";

interface MenuProps {}

export function Menu(props: PropsWithChildren<MenuProps>) {
  return <>{props.children}</>;
}

interface NavProps {}

export function Nav(props: PropsWithChildren<NavProps>) {
  return <>{props.children}</>;
}

interface ContentProps {}

export function Content(props: PropsWithChildren<ContentProps>) {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <div className={classes.appBarSpacer} />
      <Container maxWidth="lg" className={classes.container}>
        {props.children!}
        <Box pt={4} style={{ textAlign: "center" }}>
          <Copyright />
        </Box>
      </Container>
    </div>
  );
}

Menu.Nav = Nav;
Menu.Content = Content;
